

import {Component, Prop, Vue, Watch } from "vue-property-decorator";
import {PersonelEntity} from "@/entity/PersonelEntity";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import PersonelForm from "@/components/forms/PersonelForm.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import {ProgramPaths} from "@/enum/ProgramPaths";
import DeletePersonelDialog from "@/components/dialogs/DeletePersonelDialog.vue";
import PasifPersonelDialog from "@/components/dialogs/PasifPersonelDialog.vue";
import BuroDegistirDialog from "@/components/dialogs/BuroDegistirDialog.vue";


@Component({
  components: {BuroDegistirDialog, PasifPersonelDialog, DeletePersonelDialog, FormDialog, PersonelForm, DeleteDialog}
})
export default class BuroPersonelList extends Vue {
  @Prop({}) buroTuru!: number | null;
  @Prop({}) vergiDairesi!: string | null;
  @Prop({}) vergiKimlik!: number | null;
  @Prop({}) mersisNo!: number | null;
  @Prop({}) action!: any;
  @Prop({}) buroId!: number | string | null;
  @Prop({}) items!: Array<PersonelEntity>;
  /** Ofisteki toplam (silinmemiş) büro sayısı — backend'den gelir. */
  @Prop({ default: 0 }) toplamBuroSayisi!: number;

  /** Taşınacak başka büro var mı? Yoksa "Büro Değiştir" hiçbir işe yaramaz. */
  get baskaBuroVar(): boolean {
    return Number(this.toplamBuroSayisi) > 1;
  }

  // Genişlikler YÜZDE: `table-layout: fixed` ile tablo her zaman kapsayıcıya sığar,
  // yatay kaydırma çubuğuna gerek kalmaz. (Pasif Kullanıcılar tablosuyla aynı düzen.)
  // Genişlik/oran verilmez (Banka Hesap Bilgileri tablosuyla aynı sade yapı):
  // kolonlar içeriğe göre paylaşılır ve dar ekranda Vuetify kart görünümüne geçer.
  headers = [
    {text: "Adı", value: "ad", align: "start", sortable: false},
    {text: "Personel Türü", value: "roles.name", align: "start", sortable: false},
    {text: "Mail Adresi", value: "email", align: "start", sortable: false},
    {text: "İşlemler", value: "actions", align: "end", sortable: false}
  ];

  // Sayfa başına satır seçenekleri: 5 / 10 / 15 / Hepsi (-1). Varsayılan 5
  // (tabloda :items-per-page="5").
  footerProps = {
    "items-per-page-options": [5, 10, 15, -1],
    "items-per-page-all-text": "Hepsi",
    "items-per-page-text": "Sayfa başına satır:",
  };

  // --- Davet (kayıt/aktivasyon) e-postasını tekrar gönderme ---
  // Backend her personel için `davet_kalan_saniye` döndürür (0 = şimdi gönderilebilir).
  davetKalan: { [key: number]: number } = {};
  davetGonderiliyor: number | null = null;
  private davetSayaci: number | null = null;

  mounted() {
    this.davetSureleriYukle();
    // Buton 15 dk boyunca pasif kalır; kalan süre canlı olarak azalır.
    this.davetSayaci = window.setInterval(() => {
      let degisti = false;
      Object.keys(this.davetKalan).forEach((anahtar: any) => {
        if (this.davetKalan[anahtar] > 0) {
          this.davetKalan[anahtar] -= 1;
          degisti = true;
        }
      });
      if (degisti) this.davetKalan = { ...this.davetKalan };
    }, 1000);
  }

  beforeDestroy() {
    if (this.davetSayaci) window.clearInterval(this.davetSayaci);
  }

  @Watch("items")
  onItemsChanged() {
    this.davetSureleriYukle();
  }

  davetSureleriYukle() {
    const harita: { [key: number]: number } = {};
    (this.items || []).forEach((personel: any) => {
      if (personel && personel.id != null) {
        harita[personel.id] = Number(personel.davet_kalan_saniye || 0);
      }
    });
    this.davetKalan = harita;
  }

  /**
   * Buton, kaydını HENÜZ TAMAMLAMAMIŞ her personelde görünür:
   *  - onay bekleyenler (durum='onaylanmamis'),
   *  - açık daveti olanlar (davet_bekliyor),
   *  - adı/soyadı boş olanlar: kişi davet linkini hiç doldurmamıştır. (Geliştirme
   *    ortamında eklenen kullanıcı doğrudan 'aktif' olduğu için durum'a bakmak yetmez.)
   */
  davetGosterilsin(item: any): boolean {
    if (!item) return false;
    const adiYok =
      !String(item.first_name || "").trim() && !String(item.last_name || "").trim();
    return item.durum === "onaylanmamis" || item.davet_bekliyor === true || adiYok;
  }

  kalanSaniye(item: any): number {
    return this.davetKalan[item.id] || 0;
  }

  davetTooltip(item: any): string {
    const kalan = this.kalanSaniye(item);
    if (kalan > 0) {
      const dakika = Math.ceil(kalan / 60);
      return `E-posta az önce gönderildi. ${dakika} dk sonra tekrar gönderebilirsiniz.`;
    }
    return "Kayıt e-postasını tekrar gönder";
  }

  davetTekrarGonder(item: any) {
    if (this.kalanSaniye(item) > 0 || this.davetGonderiliyor !== null) return;
    this.davetGonderiliyor = item.id;
    this.$http
      .post("/api/v1/personel/" + item.id + "/davet-tekrar")
      .then((res: any) => {
        const veri = res?.data?.data ?? res?.data ?? {};
        this.$set(this.davetKalan, item.id, Number(veri.kalan_saniye || 0));
        if (veri.gonderildi) {
          (this as any).$toast?.success("Kayıt e-postası yeniden gönderildi.");
        } else {
          (this as any).$toast?.info(veri.message || "Lütfen biraz bekleyin.");
        }
      })
      .finally(() => {
        this.davetGonderiliyor = null;
      });
  }

  // `roles` bazı uçlarda dizi, bazılarında nesne dönebiliyor; ikisini de güvenle okur.
  personelTuru(item: any): string {
    const roles = item && item.roles;
    if (!roles) return "-";
    if (Array.isArray(roles)) return roles[0] && roles[0].name ? roles[0].name : "-";
    return roles.name || "-";
  }

  // Pasife düşürülenler ana listede görünmez (ayrı "Pasif Kullanıcılar" penceresinden
  // yönetilir). Backend zaten pasifleri hariç tutar; bu istemci tarafı ek güvencedir.
  get visibleItems(): Array<PersonelEntity> {
    return (this.items || []).filter((i: any) => i.durum !== 'pasif');
  }

  get getVergiKimlik() {
    let vergiKimlik = this.vergiKimlik;
    return vergiKimlik;
  }

  get getVergiDairesi() {
    let vergiDairesi = this.vergiDairesi;
    return vergiDairesi;
  }

  get getMersisNo() {
    let mersisNo = this.mersisNo;
    return mersisNo;
  }

  load() {
    this.$emit("load");
  }

  detay(item: PersonelEntity) {
    this.$router.push(ProgramPaths.ofispro + '/personel/' + item.id?.toString());
  }
}
